import request from '@/utils/request'
import {
  MedicalBusinessRegisterRequest,
  MedicalBusinessRegisterResponse
} from '@/interface/api'
import { AlertModule } from '@/store/modules/alert'

const prefix = 'api/v0/customer/web-first-reservation'

export const createTreatment = (
  medicalBusinessId: string,
  temporaryReservationId: string,
  medicalTreatment: MedicalBusinessRegisterRequest
): Promise<MedicalBusinessRegisterResponse> =>
  request({
    url: `${prefix}/${medicalBusinessId}/${temporaryReservationId}/`,
    method: 'post',
    data: medicalTreatment
  })
    .then(res => {
      const response: MedicalBusinessRegisterResponse = {
        result: true,
        message: '',
        res: res.data.data.attributes
      }
      return response
    })
    .catch(e => {
      if (
        e.response.data.data.attributes.message ===
        'already_same_phone_number_is_registered'
      ) {
        AlertModule.SetErrorAlert({
          errorTime: new Date(),
          message: '既に登録されている携帯番号です'
        })
        const response: MedicalBusinessRegisterResponse = {
          result: false,
          message: 'already_same_phone_number_is_registered',
          res: null
        }
        return response
      } else {
        AlertModule.SetErrorAlert({
          errorTime: new Date(),
          message: '診察登録に失敗しました。'
        })
        const response: MedicalBusinessRegisterResponse = {
          result: false,
          message: 'error',
          res: null
        }
        return response
      }
    })

export const createTimeframeTreatment = (
  medicalBusinessId: string,
  medicalTreatment: MedicalBusinessRegisterRequest
): Promise<MedicalBusinessRegisterResponse> =>
  request({
    url: `${prefix}/${medicalBusinessId}/`,
    method: 'post',
    data: medicalTreatment
  })
    .then(res => {
      const response: MedicalBusinessRegisterResponse = {
        result: true,
        message: '',
        res: res.data.data.attributes
      }
      return response
    })
    .catch(e => {
      if (
        e.response.data.data.attributes.message ===
        'already_same_phone_number_is_registered'
      ) {
        AlertModule.SetErrorAlert({
          errorTime: new Date(),
          message: '既に登録されている携帯番号です'
        })
        const response: MedicalBusinessRegisterResponse = {
          result: false,
          message: 'already_same_phone_number_is_registered',
          res: null
        }
        return response
      } else {
        AlertModule.SetErrorAlert({
          errorTime: new Date(),
          message: '診察登録に失敗しました。'
        })
        const response: MedicalBusinessRegisterResponse = {
          result: false,
          message: 'error',
          res: null
        }
        return response
      }
    })
